import { Typography } from "@mui/material";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { ResourceView } from "../../../dto/ResourceView";
import React from "react";

export const TitleAndPubDate = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  return (
    <Typography component="h3" variant="h6" flex={1}>
      {resource.shortTitle}{" "}
      {resource?.publicationDate?.publicationDate && (
        <span>({resource?.publicationDate?.publicationDate})</span>
      )}
    </Typography>
  );
};
